import GeoComply from './providers/geocomply'
import LexisNexis from './providers/lexisNexis'
import Xpoint from './providers/xpoint'
import utils from './common/utils'
import store from '@/store'

class GeolocationManager {
  constructor (providerName, isDebug = false) {
    this.providers = {
      GEOCOMPLY: new GeoComply(),
      LEXISNEXIS: new LexisNexis(),
      XPOINT: new Xpoint()
    }
    this.debug = isDebug
    if (!this.providers[providerName]) throw new Error(`[GeolocationManager] Unsupported provider: ${providerName}`)

    this.activeProvider = this.providers[providerName]
    if (this.debug) console.log(`[GeolocationManager] Provider: ${providerName}`)
  }

  static getInstance (providerName, isDebug) {
    if (!GeolocationManager._instance) GeolocationManager._instance = new GeolocationManager(providerName, isDebug)
    return GeolocationManager._instance
  }

  async initGeolocation (userID, sessionId, reason) {
    try {
      return await this.activeProvider.initGeolocation(userID, sessionId, reason)
    } catch (err) {
      if (this.debug) console.error('[GeolocationManager] initGeolocation Error:', err)
      throw err
    }
  }

  async getLicense (userID, sessionId, reason) {
    if (!store.getters['isLoggedIn']) return false
    try {
      const result = await this.activeProvider.getLicense(userID, sessionId, reason)
      if (this.debug) console.log('[GeolocationManager] getLicense result:', result)
      return result
    } catch (err) {
      if (this.debug) console.error('[GeolocationManager] getLicense Error:', err)
      throw err
    }
  }

  async validateGeolocation (data, userID) {
    if (!store.getters['isLoggedIn']) return false
    try {
      store.commit('setOnLoginGeolocationProgress', 'submit_geoPacket_to_server')
      let attemptId = await utils.requestAttemptId()
      if (attemptId) {
        const response = await this.activeProvider.validateGeolocation(data, userID, attemptId)
        if (this.debug) console.log('[GeolocationManager] validateGeolocation:', response)
        return response
      }
    } catch (err) {
      if (this.debug) console.error('[GeolocationManager] validateGeolocation Error:', err)
      store.commit('setGeolocationInternalError', err)
      throw err
    }
  }

  async continueGeolocation () {
    try {
      return await this.activeProvider.continueGeolocation()
    } catch (err) {
      if (this.debug) console.error('[GeolocationManager] continueGeolocation Error:', err)
      throw err
    }
  }

  async downloadPlugin () {
    try {
      return await this.activeProvider.downloadPlugin()
    } catch (err) {
      if (this.debug) console.error('[GeolocationManager] downloadPlugin Error:', err)
      throw err
    }
  }

  async disconnectService () {
    try {
      return await this.activeProvider.disconnectService()
    } catch (err) {
      if (this.debug) console.error('[GeolocationManager] disconnectService Error:', err)
      throw err
    }
  }

  async mockupGeolocation (param) {
    try {
      const location = await utils.resolveMockupGeolocation(param)
      if (this.debug) console.log('[GeolocationManager] Location:', param ? 'verified' : 'not verified')
      utils.setMockupGeolocation(param)
      return location
    } catch (err) {
      if (this.debug)console.error('[GeolocationManager] Error:', err)
      throw err
    }
  }
}
export default GeolocationManager



// WEBPACK FOOTER //
// ./src/library/geolocation/services/geolocationManager.js